import { createContext, useEffect } from 'react';
import LogRocket from 'logrocket';
import { useSelector } from 'react-redux';

const LogRocketContext = createContext();

export const LogRocketProvider = ({ children }) => {
    const { userToken } = useSelector(state => state.sharedState);

    useEffect(() => {
        if(process.env.NODE_ENV === 'development' || userToken == null) return;

        LogRocket.init('f5sb9k/grant-advance-frontend');
        
        // OneClick login (Sales demo): record the session under the salesperson
        const salesUser = userToken.AdminUserName;

        LogRocket.identify(salesUser ? `sales:${salesUser}` : userToken.Id, {
            name: salesUser ?? userToken.UserName,
            email: userToken.email,
            ...(salesUser && {
                isDemoSession: true,
                salesUser,
                demoAccountUserName: userToken.UserName,
            }),
        });
    }, [userToken]);

    return (
        <LogRocketContext.Provider value={null}>
            {children}
        </LogRocketContext.Provider>
    );
};
